import SessionState from "../stateTypes/sessionState";
import ConfigurationState from "../stateTypes/configurationState";
import ImagesState from "../stateTypes/imagesState";
import MetadataState from "../stateTypes/metadataState";
import FilterState from "../stateTypes/filterState";
import ErrorState from "../stateTypes/errorState";
import SideMenuState from "../stateTypes/sideMenuState";
import { isMenuCategory } from "../../utilities/itemUtilities";

export const getSessionId = ({ session }: { session: SessionState }) => session.sessionData!.sessionId;
export const getAppConfig = ({ session }: { session: SessionState }) => session.appConfig;
export const getIsLoading = ({ session }: { session: SessionState }) => session.isLoading;
export const getFrontendSettings = ({ session }: { session: SessionState }) => session.frontendSettings;
export const getLanguage = ({ session }: { session: SessionState }) => session.language;
export const getShowPrice = ({ session }: { session: SessionState }) => session.showPrice;
export const getComposedUrl = ({ session }: { session: SessionState }) => session.sessionData?.composedUrl;
export const getGuiResourceUrl = ({ session }: { session: SessionState }) => session.sessionData?.guiResourcesUrl;
export const getIconUrl = ({ session }: { session: SessionState }) => session.sessionData?.bumps?.[0]?.iconUrl;
export const getPublicOutUrl = ({ session }: { session: SessionState }) =>
    session.sessionData?.bumps?.[0]?.publicOutUrl;
export const getSeries = ({ session }: { session: SessionState }) => session.sessionData?.bumps?.[0]?.series;
export const getBackendFlavor = ({ session }: { session: SessionState }) => session.sessionData?.backendFlavor;
export const getAccount = ({ session }: { session: SessionState }) => session.account;
export const getShowFilters = ({ session }: { session: SessionState }) => session.showFilters;
export const getGuiTranslations = ({ session }: { session: SessionState }) => session.guiTranslation;
export const getSummaryData = ({ session }: { session: SessionState }) => session.summaryData;
export const getAppVersion = ({ session }: { session: SessionState }) => session.appVersion;
export const getTouchScreen = ({ session }: { session: SessionState }) => session.touchScreen;
export const getAppCustomization = ({ session }: { session: SessionState }) => session.appCustomization;
export const getShowVirtualKeyboard = ({ session }: { session: SessionState }) => session.showVirtualKeyboard;

export const getConfigurationString = ({ configuration }: { configuration: ConfigurationState }) =>
    configuration.configurationString;
export const getConfigurationAsString = ({ configuration }: { configuration: ConfigurationState }) =>
    configuration.configurationString;
export const getSelectedMenu = ({ configuration }: { configuration: ConfigurationState }) => configuration.selectedMenu;
export const getMenuCache = ({ configuration }: { configuration: ConfigurationState }) => configuration.menus;
export const getCurrentSummaries = ({ configuration }: { configuration: ConfigurationState }) =>
    configuration.summaries;
export const getActiveMenuPath = ({ configuration }: { configuration: ConfigurationState }) =>
    configuration.activeMenuPath;
export const getActiveSurfaceItems = ({ configuration }: { configuration: ConfigurationState }) =>
    configuration.activeSurfaceProductIds;
export const getBreadcrumbs = ({ configuration }: { configuration: ConfigurationState }) =>
    configuration.activeMenuPath.filter(menu => !isMenuCategory(menu.id));
export const getLayoutGroups = ({ configuration }: { configuration: ConfigurationState }) => configuration.layoutGroups;
export const getActiveLayoutGroup = ({ configuration }: { configuration: ConfigurationState }) =>
    configuration.activeLayoutGroup;
export const getModelId = ({ configuration }: { configuration: ConfigurationState }) => configuration.modelId;
export const getCategory = ({ configuration }: { configuration: ConfigurationState }) => configuration.category;
export const getTotalPrice = ({ configuration }: { configuration: ConfigurationState }) => configuration.totalPrice;
export const getTotalPriceText = ({ configuration }: { configuration: ConfigurationState }) =>
    configuration.totalPriceText;
export const getFavoriteOverlayActive = ({ configuration }: { configuration: ConfigurationState }) =>
    configuration.favoriteOverlayActive;
export const getLayoutOverlayActive = ({ configuration }: { configuration: ConfigurationState }) =>
    configuration.layoutOverlayActive;

export const getMaskMetadata = ({ images }: { images: ImagesState }) => images.maskMetadata;
export const getImageAndMask = ({ images }: { images: ImagesState }) => images.imageAndMask;
export const getMaskElement = ({ images }: { images: ImagesState }) => images.maskElement;
export const getMaskData = ({ images }: { images: ImagesState }) => images.maskData;

export const getMetadata = ({
    metadata,
    configuration,
}: {
    metadata: MetadataState;
    configuration: ConfigurationState;
}) => (configuration.modelId && metadata.metadata[configuration.modelId]) || null;

export const getProductInfo = ({ metadata }: { metadata: MetadataState }) => metadata.productInfo;
export const getProductIds = ({ metadata }: { metadata: MetadataState }) => metadata.productIds;

export const getSideMenuOpen = ({ sideMenu }: { sideMenu: SideMenuState }) => sideMenu.sideMenuOpen;
export const getSideMenuContentLoading = ({ sideMenu }: { sideMenu: SideMenuState }) => sideMenu.contentLoading;
export const getSideMenuSide = ({ sideMenu }: { sideMenu: SideMenuState }) => sideMenu.side;

export const getFilterTypes = ({ filters }: { filters: FilterState }) => filters.filterTypes;
export const getFilters = ({ filters }: { filters: FilterState }) => filters.filters;
export const getItemFilter = ({ filters }: { filters: FilterState }) => filters.itemFilter;
export const getFilteredItems = ({ filters }: { filters: FilterState }) => filters.filteredItems;
export const getCurrentFilterTab = ({ filters }: { filters: FilterState }) => filters.currentTabName;
export const getAccountFilterTexts = ({ filters }: { filters: FilterState }) => filters.accountFilterTexts;
export const getMenuDynamicType = ({ filters }: { filters: FilterState }) => {
    let menuDynamicType: string = "";
    filters.filteredItems.some(item => {
        if (item.dynamicType) {
            menuDynamicType = item.dynamicType;
            return true;
        }
        return false;
    });
    return menuDynamicType;
};
export const getFilteredMenu = ({ filters }: { filters: FilterState }) => filters.filteredMenu;

export const getError = ({ error }: { error: ErrorState }) => error.error;
